import { DATE_PRESET_OPTS } from './reportGeneratorUtils';
import type { Option } from '@types';

export const reportTypeOpts: Option[] = [
	{
		label: 'Detailed Shipment report (incl. DIFOT)',
		value: 'detailed_shipment_shipper_report',
	},
	{
		label: 'Shipment Invoice report',
		value: 'shipment_shipper_invoice_report',
	},
];

export const scopeOpts: Option[] = [
	{ label: 'Pick-Up date', value: 'PICKUP_DATE' },
	{ label: 'Drop-Off date', value: 'DROP_OFF_DATE' },
	{ label: 'Invoice sent at', value: 'INVOICE_SENT_AT' },
	{ label: 'Invoice reference', value: 'INVOICE_REFERENCE' },
	{ label: 'Order #', value: 'ORDER_NUMBER' },
];

export const shipperScheduledPresetToInterval: Record<string, { last_num: string; last_period: string }> = {
	today: { last_num: '1', last_period: 'DAY' },
	yesterday: { last_num: '1', last_period: 'DAY' },
	this_week: { last_num: '1', last_period: 'WEEK' },
	last_7_days: { last_num: '7', last_period: 'DAY' },
	this_month: { last_num: '1', last_period: 'MONTH' },
	last_30_days: { last_num: '30', last_period: 'DAY' },
};

export const shipperScheduledSpecialPresets: Record<string, 'TOMORROW' | 'THIS_YEAR' | 'LAST_YEAR' | 'LAST_MONTH'> = {
	tomorrow: 'TOMORROW',
	this_year: 'THIS_YEAR',
	last_year: 'LAST_YEAR',
	last_month: 'LAST_MONTH',
};

const scheduledAllowedPresets = ['today', 'tomorrow', 'yesterday', 'this_week', 'last_7_days', 'this_month', 'last_month', 'last_30_days', 'this_year', 'last_year'];
const generateNowAllowedPresets = [...scheduledAllowedPresets, 'date_range', 'specific_date'];

export const shipperPresetOpts: Option[] = DATE_PRESET_OPTS.filter((o: Option) => generateNowAllowedPresets.includes(o.value));
const shipperScheduledPresetOpts: Option[] = DATE_PRESET_OPTS.filter((o: Option) => scheduledAllowedPresets.includes(o.value));

export const shipperGetScopeOpts = (reportType: string): Option[] => {
	if (reportType === 'detailed_shipment_shipper_report') {
		return scopeOpts.filter((opt) => opt.value !== 'INVOICE_SENT_AT' && opt.value !== 'INVOICE_REFERENCE');
	}
	return scopeOpts;
};

export const shipperGetScheduledPresetOpts = (_reportType: string, _filterType: string): Option[] =>
	shipperScheduledPresetOpts;
